import { useEffect } from "react";
import { BuilderPage } from "./builder";
import { GeckoPage } from "./components/GeckoPage";
import { HomePage } from "./components/HomePage";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";
import {
  supportedLocales,
  translations,
} from "./i18n/locales";

function getRoute() {
  const segments = window.location.pathname
    .toLowerCase()
    .split("/")
    .filter(Boolean);
  const locale = supportedLocales.includes(segments[0]) ? segments[0] : "en";
  const page = segments.includes("gecko") ? "gecko" : "home";
  return { locale, page };
}

function detectBrowserLocale() {
  const browserLang = (navigator.language || "en").split("-")[0].toLowerCase();
  return supportedLocales.includes(browserLang) ? browserLang : "en";
}

export default function App() {
  const { locale, page } = getRoute();
  const copy = translations[locale];

  useEffect(() => {
    const segments = window.location.pathname
      .toLowerCase()
      .split("/")
      .filter(Boolean);

    if (!supportedLocales.includes(segments[0])) {
      const detected = detectBrowserLocale();
      const rest = segments.join("/");
      window.location.replace(`/${detected}/${rest}`);
    }
  }, []);
  const navigation = [
    { href: "#accounts", label: copy.home.accountsTitle },
    ...copy.home.products.map((product) => ({
      href: product.id === "gecko" ? "https://gecko.imajnet.net/" : `#${product.id}`,
      label: product.title,
    })),
  ];

  useEffect(() => {
    const title = page === "gecko" ? copy.gecko.metaTitle : copy.meta.title;
    const description =
      page === "gecko"
        ? copy.gecko.metaDescription || copy.meta.description
        : copy.meta.description;
    document.documentElement.lang = locale;
    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.append(meta);
    }
    meta.content = description;

    const canonicalHref = `https://www.imajnet.net/${locale}/${page === "gecko" ? "gecko/" : ""}`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.append(canonical);
    }
    canonical.href = canonicalHref;
  }, [copy, locale, page]);

  return (
    <div className="app-shell">
      <SiteHeader
        locale={locale}
        navigation={navigation}
        page={page}
        copy={copy.common}
      />
      <BuilderPage locale={locale}>
        {page === "gecko" ? (
          <GeckoPage copy={copy.gecko} />
        ) : (
          <HomePage locale={locale} copy={copy.home} />
        )}
      </BuilderPage>
      <SiteFooter copy={copy.common} locale={locale} page={page} />
    </div>
  );
}
